import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LogEvent } from 'src/app/interfaces/log'
import { KakaoService } from 'src/app/services/kakao/kakao.service'
import { LogService } from 'src/app/services/log/log.service'
import { UserService } from 'src/app/services/user/user.service'

@Component({
  selector: 'app-quiz-profile-renewal',
  templateUrl: './quiz-profile-renewal.component.html',
  styleUrls: ['./quiz-profile-renewal.component.scss'],
})
export class QuizProfileRenewalComponent implements OnInit {
  @Input() firstName: string | undefined
  @Input() lastName: string | undefined
  @Input() showTitle?: boolean = true
  @Input() showDescription?: boolean = true
  @Input() hideProfile = false
  @Input() type: 'host' | 'guest' = 'host'
  @Input() loginDescription = '월드컵 결과로\n나와 친구의 취향 궁합을 분석해드려요'
  @Input() from: string = 'quiz_profile'
  @Input() disableHideProfile = false
  @Input() isHostLoginNeeded = true
  @Output() firstNameChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() lastNameChange: EventEmitter<string> = new EventEmitter<string>()
  @Output() hideProfileChange: EventEmitter<boolean> = new EventEmitter<boolean>()

  constructor(public userService: UserService, private kakaoService: KakaoService, private logService: LogService) {}

  get isLoggedIn(): boolean {
    return this.userService.isLoggedIn
  }

  get title(): string {
    if (!this.hideProfile) {
      return '나의 프로필'
    }
    return '내 이름 입력'
  }

  ngOnInit(): void {}

  onHideButtonClicked(): void {
    this.hideProfile = !this.hideProfile
    this.hideProfileChange.emit(this.hideProfile)
  }

  onChangeValue(type: 'firstName' | 'lastName'): void {
    // login O host 이름 입력시
    if (type === 'firstName') {
      this.firstNameChange.emit(this.firstName)
    } else {
      this.lastNameChange.emit(this.lastName)
    }
  }

  handleFirstNameChange(newFirstName: string) {
    this.firstName = newFirstName
    this.firstNameChange.emit(newFirstName)
  }

  handleLastNameChange(newLastName: string) {
    this.lastName = newLastName
    this.lastNameChange.emit(newLastName)
  }

  onClickLogin(): void {
    this.logService.eventLogging(LogEvent.KAKAO_LOGIN_CLICKED, { from: this.from })
    this.kakaoService.login(location.pathname + location.search)
  }
}
